/* eslint-disable */
import React from "react";
import * as MUI from "@material-ui/core";
import cn from "classnames";
import { useStylesInput, useStylesLabel, useStyles } from "./styles";
import { AccessTime } from "@material-ui/icons";

function handler(this: HTMLInputElement) {
  this.selectionStart = this.selectionEnd;
}
const prevent = (e) => e.preventDefault();
export default ({ open, ...props }) => {
  const classes = useStyles(props);
  const ref = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (ref.current) {
      ref.current!.addEventListener("select", handler, false);
      return () => {
        ref.current!.removeEventListener("select", handler);
      };
    }
  }, []);

  return (
    <MUI.TextField
      {...props}
      ref={ref}
      onChange={prevent}
      classes={classes}
      InputProps={{
        className: cn({ focus: open }),
        classes: useStylesInput(props),
        endAdornment: <AccessTime className={cn(classes.icon, { focus: open })} />,
      }}
      InputLabelProps={{
        shrink: true,
        className: cn({ focus: open }),
        classes: useStylesLabel(props),
      }}
    />
  );
};
